import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle
} from '@/components/ui/alert-dialog';

interface ConfirmWriteRunProps {
	open: boolean;
	label: string;
	onOpenChange: (open: boolean) => void;
	onConfirm: () => void;
}

/** Asks before a write tool runs, since it changes data on the live integration. */
export const ConfirmWriteRun = ({ open, label, onOpenChange, onConfirm }: ConfirmWriteRunProps) => (
	<AlertDialog open={open} onOpenChange={onOpenChange}>
		<AlertDialogContent>
			<AlertDialogHeader>
				<AlertDialogTitle>Do you want to run this tool call?</AlertDialogTitle>
				<AlertDialogDescription>
					{`${label} changes data on your live integration. This cannot be undone.`}
				</AlertDialogDescription>
			</AlertDialogHeader>
			<AlertDialogFooter>
				<AlertDialogCancel>Cancel</AlertDialogCancel>
				<AlertDialogAction onClick={onConfirm}>Run</AlertDialogAction>
			</AlertDialogFooter>
		</AlertDialogContent>
	</AlertDialog>
);
